export default __webpack_public_path__ + "static/media/webcam5.b18ffb0f.jfif";